export const getRestorableCategoryIds = (
  stashedCategoryIds: string[],
  availableCategories: { id: string }[]
): string[] => {
  const availableIds = new Set(availableCategories.map((category) => category.id));
  return stashedCategoryIds.filter((id) => availableIds.has(id));
};
